
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Chromangix - Portfolio</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&display=swap" rel="stylesheet">
    <link rel="preload" href="/model/room_portfolio.glb" as="fetch" crossorigin="anonymous">
    <link rel="stylesheet" href="./style.css">
</head>
<body>
    <div id="splash" class="splash">
        <div class="splash__card">
            <p class="splash__title" data-text="Roomangix Portfolio Showcase 2025">
                <span class="splash__title-text" aria-hidden="true"></span>
                <span class="visually-hidden">Roomangix Portfolio Showcase 2025</span>
            </p>
            <p class="splash__subtitle">
                <span class="splash__subtitle-text" aria-hidden="true"></span>
                <span class="visually-hidden">Click start to begin</span>
            </p>
            <div class="splash__progress" id="splash-progress" aria-hidden="true">
                <div class="splash__progress-bar-track">
                    <div class="splash__progress-bar" id="splash-progress-bar"></div>
                </div>
                <span class="splash__progress-label" id="splash-progress-label">Loading…</span>
            </div>
            <button id="splash-enter" type="button" class="splash__start">START</button>
        </div>
        <div class="splash__footer">
            <button id="splash-enter-silent" type="button" class="splash__silent">enter without sound :(</button>
            <p class="splash__hint splash__hint--desktop">use left/right click and mouse wheel to navigate!</p>
            <p class="splash__hint splash__hint--mobile">use one or two fingers to navigate!</p>
        </div>
    </div>

    <button id="music-toggle" type="button" class="music-toggle" hidden aria-label="Play music" aria-pressed="false">
        <svg class="music-toggle__icon music-toggle__icon--on" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 9v6h4l5 4V5L8 9H4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
            <path d="M16 8.5a4.5 4.5 0 0 1 0 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M18.5 6a7.5 7.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg class="music-toggle__icon music-toggle__icon--off" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 9v6h4l5 4V5L8 9H4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
            <path d="M16 8.5l5 7.5M21 8.5l-5 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </button>

    <div id="passion-panel-backdrop" class="passion-panel-backdrop" aria-hidden="true"></div>
    <aside id="passion-panel" class="passion-panel" role="dialog" aria-modal="true" aria-labelledby="passion-panel-title" aria-hidden="true">
        <button id="passion-panel-close" type="button" class="passion-panel__close" aria-label="Close">
            ×
        </button>
        <p class="passion-panel__label">Passion</p>
        <h2 id="passion-panel-title" class="passion-panel__title"></h2>
        <div id="passion-panel-media" class="passion-panel__media" hidden>
            <img id="passion-panel-image" class="passion-panel__image" alt="">
            <video id="passion-panel-video" class="passion-panel__video" muted loop playsinline autoplay></video>
        </div>
        <p id="passion-panel-body" class="passion-panel__body"></p>
    </aside>

    <canvas class="webgl"></canvas>
    <script type="module" src="./script.js"></script>

</body>
</html>
